/**
 * Instalar la web como aplicación — `OD-0065` (D-01 A, «Solo web instalable»).
 *
 * El mismo bloque en dos sitios: Configuración › Mi cuenta, para quien ya
 * trabaja con Faktelio, y `/instalar`, a donde lleva el botón «Descarga la
 * aplicación de escritorio» de faktelio.com. Qué se enseña lo decide
 * `pwa/instalar.ts` según lo que permita el navegador.
 */
import { useState } from "react";
import { t } from "../i18n/es";
import { pedirInstalacion, useComoInstalar } from "../pwa/instalar";
import { Boton } from "../ui/primitivas";

export function InstalarAplicacion({
  titulo,
  variante = "secundario",
}: {
  /** El subtítulo del bloque; `null` cuando la pantalla ya lleva el suyo. */
  titulo: string | null;
  variante?: "principal" | "secundario";
}) {
  const como = useComoInstalar();
  const [instalando, setInstalando] = useState(false);

  async function instalar(): Promise<void> {
    setInstalando(true);
    await pedirInstalacion().catch(() => undefined);
    setInstalando(false);
  }

  return (
    <section className="instalar-app" aria-labelledby={titulo === null ? undefined : "titulo-instalar"}>
      {titulo === null ? null : (
        <h3 id="titulo-instalar" className="subtitulo">
          {titulo}
        </h3>
      )}
      {como === "instalada" ? (
        <p>{t.cuenta.instalar.instalada}</p>
      ) : (
        <>
          <p className="ayuda-neutra">{t.cuenta.instalar.detalle}</p>
          {como === "boton" ? (
            <Boton variante={variante} onClick={() => void instalar()} deshabilitado={instalando}>
              {instalando ? t.cuenta.instalar.instalando : t.cuenta.instalar.boton}
            </Boton>
          ) : (
            <p>
              {como === "safari-mac"
                ? t.cuenta.instalar.safariMac
                : como === "ios"
                  ? t.cuenta.instalar.ios
                  : t.cuenta.instalar.otro}
            </p>
          )}
        </>
      )}
    </section>
  );
}
